import useSecureAPI from "../hooks/usesecureapi";

const useReportService = () => {
  const secureAPI = useSecureAPI();

  const getReportsForCustomer = async (id: number) => {
    const response = await secureAPI.get(`Report/stocksummary/${id}`);
    return response.data;
  };
  const getStockInOutReportForCustomer = async (filters: any) => {
    const response = await secureAPI.post(`Report/stockinout`, filters);
    return response.data;
  };

  const getInboundReportForTenant = async (filters: any) => {
    const response = await secureAPI.post(`Report/inbound`, filters);
    return response.data;
  };
  const getOrderReportForTenant = async (filters: any) => {
    const response = await secureAPI.post(`Report/outbound`, filters);
    return response.data;
  };

  return {
    getReportsForCustomer,
    getStockInOutReportForCustomer,
    getInboundReportForTenant,
    getOrderReportForTenant,
  };
};

export default useReportService;
